@if (!store.isSummary) {
    <section>
        <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    </section>
}

@if (showPurchasePrice()) {
    <purchase-price-amount></purchase-price-amount>
}
